<script setup lang="ts">
import { computed } from 'vue';
import { CompromissoForm } from '~/lib/fw';
import { useAuthenticationStore } from '~/stores/authenticationStore';

interface Props {
  pastaCodigos?: string[];
  compromisso?: any;
  fluxo?: any;
}

const props = defineProps<Props>();

const emit = defineEmits(['close']);

const authenticationStore = useAuthenticationStore();
const buttonsDisabled = computed(() => {
  if (!props.compromisso) {
    return false;
  }
  return authenticationStore.user!.id !== props.compromisso.responsavelCodigo;
});
</script>

<template>
  <CompromissoForm
    action="transferencia-responsavel-negocial-para-outra-area/transferencia-responsavel-negocial-para-outra-area-nao-confirmada"
    :pasta-codigos="props.pastaCodigos ?? []"
    :compromisso-codigos="props.compromisso ? [props.compromisso.codigo] : []"
    :wait-for-result="true"
    :show-upload-files="false"
    :submit-button-disabled="buttonsDisabled"
    @close="() => emit('close')"
  >
    <template #form>
      <a-alert
        type="warning"
        message="Sua aprovação não foi confirmada. Clique em salvar para confirmar a ciência."
        show-icon
        style="margin-bottom: 24px"
      ></a-alert>
    </template>
  </CompromissoForm>
</template>
